<div>
    <h2 class="headline-05 my-4 text-[#382100]">Nombre del paciente</h2>
    <mat-radio-group [(ngModel)]="selectedPatient">
        <div class="flex items-center border border-[#553400] rounded-lg px-4 py-2">
            <div class="flex items-center gap-2">
                <mat-icon>person</mat-icon>
                <div>
                    <p class="font-semibold">{{ nameOwner }}</p>
                    <p class="paragraph-small text-[#97795B]">Titular</p>
                </div>
            </div>
            <mat-radio-button class="ml-auto" value="titular"></mat-radio-button>
        </div>
    </mat-radio-group>
</div>
<!-- DEPENDIENTES OCULTOS TEMPORALMENTE
<div>
    <h2 class="headline-03 mt-4 mb-1 text-[#382100]">Dependientes</h2>
    <mat-radio-group [(ngModel)]="selectedPatient" class="space-y-2 block">
        <div *ngFor="let dep of dependent" class="flex items-center border border-[#553400] rounded-lg px-4 py-2">
            <div class="flex items-center gap-2">
                <mat-icon>person</mat-icon>
                <div>
                    <p class="paragraph-medium">{{ dep.name }}</p>
                    <p class="paragraph-small text-[#97795B]">{{ dep.catalog.description }}</p>
                </div>
            </div>
            <mat-radio-button class="ml-auto" [value]="dep.name"></mat-radio-button>
        </div>
    </mat-radio-group>
</div>
FIN DEPENDIENTES OCULTOS TEMPORALMENTE -->
<div style="margin-top: 15px;">
    <h2 class="headline-05 flex items-center gap-2 text-[#382100] mt-3 mb-1">
        <mat-icon>location_on</mat-icon> Dirección
    </h2>
    <!-- Estado de carga de ubicación -->
    <div *ngIf="isLoadingLocation" class="border border-gray-300 rounded-lg p-2 flex justify-between items-center mb-2 bg-gray-50">
        <div class="flex items-center gap-2">
            <mat-icon class="text-gray-500 animate-spin text-sm">refresh</mat-icon>
            <p class="paragraph-medium text-gray-500">Cargando ubicación...</p>
        </div>
    </div>
    
    <!-- Ubicación actual del mapa -->
    <div *ngIf="currentMapLocation && !isLoadingLocation" 
         class="border border-[#0E365A] rounded-lg p-2 mb-2 bg-blue-50"
         [class.border-blue-500]="selectedAddress === currentMapLocation">
        <div class="flex justify-between items-center cursor-pointer" (click)="selectAddress(currentMapLocation)">
            <div>
                <p class="paragraph-medium flex items-center gap-1">
                    <mat-icon class="text-blue-600 text-sm">my_location</mat-icon>
                    {{ currentMapLocation.colony }}
                </p>
                <p class="paragraph-default text-[#97795B]">{{ currentMapLocation.identifier }}</p>
            </div>
            <button mat-icon-button (click)="toggleEditCurrentLocation($event)">
                <mat-icon style="color: #eca136;">edit</mat-icon>
            </button>
        </div>
        
        <!-- Buscador desplegable -->
        <div *ngIf="isEditingCurrentLocation" class="mt-3 pt-3 border-t border-blue-200 bg-blue-25">
            <p class="text-xs text-blue-600 mb-2">Busca una dirección y luego ajusta el pin en el mapa:</p>            
            <!-- Input de búsqueda integrado -->
            <div class="mb-3">                
                <div class="flex items-center bg-white rounded-lg border-2 border-blue-300 shadow-sm">
                    <mat-icon class="text-blue-600 ml-3 text-sm">search</mat-icon>
                    <input 
                        class="flex-1 px-3 py-2 text-sm border-none outline-none rounded-lg"
                        type="text"
                        #searchInput
                        placeholder="Buscar dirección..."
                        (input)="onSearchInput($event)"
                    />
                    <mat-icon *ngIf="isSearching" class="text-blue-600 mr-3 animate-spin text-sm">refresh</mat-icon>
                </div>
            </div>
        
            
        </div>
    </div>
    
    <div *ngIf="addresses.length > 0">
        <div class="border border-[#553400] rounded-lg p-2 flex justify-between items-center mb-2 cursor-pointer"
            [class.border-blue-500]="selectedAddress === addresses[0]" (click)="selectAddress(addresses[0])">
            <div>
                <p class="paragraph-medium">{{ addresses[0].colony }}.{{ addresses[0].streetNumber }}</p>
                <p class="paragraph-default text-[#97795B]"> {{ addresses[0].identifier }}. {{ addresses[0].city }}</p>
            </div>
        </div>
        <div *ngIf="showAllAddresses">
            <div *ngFor="let dir of addresses.slice(1)"
                class="border border-[#553400] rounded-lg p-2 flex justify-between items-center mb-2 cursor-pointer"
                [class.border-blue-500]="selectedAddress === dir" (click)="selectAddress(dir)">
                <div>
                    <p class="paragraph-medium">{{ dir.colony }}.{{ dir.streetNumber }}</p>
                    <p class="paragraph-default text-[#97795B]">{{ dir.identifier }}. {{ dir.city }}</p>
                </div>
            </div>
        </div>
    </div>
    <button class="w-full mt-2 border border-[#0E365A] rounded-lg p-1 flex justify-between items-center"
        (click)="toggleAddresses()">
        <p>{{ showAllAddresses ? 'Ocultar direcciones' : 'Cambiar dirección' }}</p>
        <mat-icon>{{ showAllAddresses ? 'remove' : 'add' }}</mat-icon>
    </button>
    <button class="w-full mt-1 text-xs text-[#0E365A] underline cursor-pointer bg-transparent border-none"
        (click)="goToAddAddress()">
        Agregar dirección
    </button>
</div>
<div>
    <h2 class="headline-04 mt-4 mb-2">Referencias</h2>
    <p class="text-sm text-[#97795B] mb-2">Entre calles, o referencias que ayuden a localizarte.</p>
    <mat-form-field class="w-full" appearance="fill">
        <input matInput placeholder="Escribe aquí..." [(ngModel)]="reference" />
    </mat-form-field>
</div>
<button class="bg-[#2D1B0B] text-white w-full py-2 rounded-full cursor-pointer" (click)="goToConfirm()">
    Confirmar
</button>